export const testNameChangeModalTitleDataTestId =
  'test-title-update-modal-title'
export const deleteAndExitButtonDataTestId = 'delete-and-exit-button'
export const continueOrSaveButtonDataTestId = 'continue-or-save-button'
